import { render, staticRenderFns } from "./MinesControls.vue?vue&type=template&id=4dc19ffc&scoped=true"
import script from "./MinesControls.vue?vue&type=script&lang=js"
export * from "./MinesControls.vue?vue&type=script&lang=js"
import style0 from "./MinesControls.vue?vue&type=style&index=0&id=4dc19ffc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4dc19ffc",
  null
  
)

export default component.exports